var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0225 2.91016C8.71253 2.91016 6.02253 5.60016 6.02253 8.91016V11.8002C6.02253 12.4102 5.76253 13.3402 5.45253 13.8602L4.30253 15.7702C3.59253 16.9502 4.08253 18.2602 5.38253 18.7002C9.69253 20.1402 14.3425 20.1402 18.6525 18.7002C19.8625 18.3002 20.3925 16.8702 19.7325 15.7702L18.5825 13.8602C18.2825 13.3402 18.0225 12.4102 18.0225 11.8002V8.91016C18.0225 5.61016 15.3225 2.91016 12.0225 2.91016Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8719 3.20043C13.5619 3.11043 13.2419 3.04043 12.9119 3.00043C11.9519 2.88043 11.0319 2.95043 10.1719 3.20043C10.4619 2.46043 11.1819 1.94043 12.0219 1.94043C12.8619 1.94043 13.5819 2.46043 13.8719 3.20043Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0234 19.0596C15.0234 20.7096 13.6734 22.0596 12.0234 22.0596C11.2034 22.0596 10.4434 21.7196 9.90344 21.1796C9.36344 20.6396 9.02344 19.8796 9.02344 19.0596",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.c117e4cd8ccd6fa1bdfe3040b8e604d4.svg";
export { ForwardRef as ReactComponent };